import avatarList from '@/assets/json/avatars.json'
export const avatarTools = {
  computed: {
    avatarInfo () {
      let avInfo = {
        family: null,
        format: 'initials',
        source: null,
        fallback: null
      }
      const families = avatarList.avatars.families
      const len = families.length
      for (let i = 0; i < len; i++) {
        const avObj = families[i].list.find(o => o.key === this.avatarKey)
        if (avObj) {
          const sourcePath = this.getImagePath(families[i].family, avObj.fileName, avObj.format)
          const fallbackPath = avObj.fallback ? this.getImagePath(families[i].family, avObj.fileName, avObj.fallback) : null
          avInfo = {
            family: families[i].family,
            format: avObj.format,
            source: sourcePath,
            fallback: fallbackPath
          }
          break
        }
      }
      return avInfo
    }
  },
  methods: {
    getAvDetails (avatarKey) {
      let avInfo = {
        family: null,
        format: 'initials',
        source: null,
        fallback: null
      }
      // loop through families to find key.  Break once found.
      const families = avatarList.avatars.families
      const len = families.length
      for (let i = 0; i < len; i++) {
        const avObj = families[i].list.find(o => o.key === avatarKey)
        if (avObj) {
          const avatarPath = this.getImagePath(families[i].family, avObj.fileName, avObj.format)
          const fallbackPath = avObj.fallback ? this.getImagePath(families[i].family, avObj.fileName, avObj.fallback) : null
          avInfo = {
            family: families[i].family,
            format: avObj.format,
            fileName: avatarPath,
            fallbackPath: fallbackPath
          }
          break
        }
      }
      return avInfo
    },
    getImagePath (family, fileName, format) {
      let path = null
      if (format.toLowerCase() !== 'initials') {
        if (format.toLowerCase() === 'svg') {
          return `/img/avatars/${family}/${fileName}.${format.toLowerCase()}`
        } else {
          // is a bitmap
          // First get the magnification.
          let imgSize = '@0.5x'
          switch (this.$mq) {
            case 'mobile':
              imgSize = '@0.33x'
              break
            case 'tablet':
              imgSize = '@0.5x'
              break
            case 'desktop':
              imgSize = '@0.5x'
              break
            default:
              imgSize = '@0.5x'
          }
          path = `/img/avatars/${family}/${fileName}${imgSize}.${format.toLowerCase()}`
        }
      }
      return path
    },
    getAvatarInfo (avatarKey) {
      let avInfo = null
      // loop through families to find key.  Break once found.
      const families = avatarList.avatars.families
      const len = families.length
      for (let i = 0; i < len; i++) {
        const avObj = families[i].list.find(o => o.key === this.avatarKey)
        if (avObj) {
          const sourcePath = this.getImagePath(families[i].family, avObj.fileName, avObj.format)
          // fallback does not (necessarily) exist for SVG or initials, so check
          const fallbackPath = avObj.fallback ? this.getImagePath(families[i].family, avObj.fileName, avObj.fallback) : null
          avInfo = {
            family: families[i].family,
            format: avObj.format,
            source: sourcePath,
            fallback: fallbackPath
          }
          break
        }
      }
      this.avatarInfo = avInfo
    }
  }
}
